import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-context-loading',
  templateUrl: './context-loading.component.html',
  styleUrls: ['./context-loading.component.scss']
})
export class ContextLoadingComponent implements OnInit {

  @Input() heightPage?: string
  @Input() bg?: string

  constructor() { }

  ngOnInit() {
  }

}
